import type { ErrorEvent } from '@sentry/angular';

// DocuSeal's embed (the remote cdn.docuseal.com/js/form.js that @docuseal/angular loads) measures itself on a
// $nextTick queued at mount, and from an IntersectionObserver it never disconnects. Neither is cancelled when the
// widget is removed, so one that fires after the sign-here step is gone reads offsetWidth of null on the detached
// tree. Nothing is on screen any more and the script is not ours to fix (KOR-15255, Sentry ROCKET-CAPTURE-LINX-5J).
const DOCUSEAL_SCRIPT = /\/\/cdn\.docuseal\.com\/js\/form\.js/;
const DETACHED_MEASURE = /reading 'offsetWidth'/;

/** True only for that one teardown error, thrown from DocuSeal's script: every other DocuSeal error is still reported. */
export const isDocusealTeardownError = (event: ErrorEvent): boolean => {
  const exception = event.exception?.values?.at(-1);
  const thrownIn = exception?.stacktrace?.frames?.at(-1)?.filename ?? '';

  return DETACHED_MEASURE.test(exception?.value ?? '') && DOCUSEAL_SCRIPT.test(thrownIn);
};
